import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { useLanguage } from '../context/LanguageContext';

const SelectedMoments = () => {
  const { language } = useLanguage();

  const sections = [
    {
      title: language === 'es' ? 'Momentos de Lanzamiento y Campaña' : 'Launch & Campaign Moments',
      pieces: [
        { objective: 'Product launch awareness', format: 'Reels' },
        { objective: 'Brand campaign storytelling', format: 'Ad' },
        { objective: 'Collection reveal', format: 'Reels' },
        { objective: 'Event announcement', format: 'Still' },
        { objective: 'Behind-the-scenes narrative', format: 'Reels' },
      ],
    },
    {
      title: language === 'es' ? 'Gifting de Marca y Drops' : 'Branded Gifting & Drops',
      pieces: [
        { objective: 'Unboxing experience', format: 'Reels' },
        { objective: 'Gift guide feature', format: 'Still' },
        { objective: 'Limited edition reveal', format: 'Reels' },
        { objective: 'Curated selection showcase', format: 'Ad' },
      ],
    },
    {
      title: language === 'es' ? 'Estilo de Vida de Fundadora (Curado)' : 'Founder Lifestyle (Curated)',
      pieces: [
        { objective: 'Day-in-the-life narrative', format: 'Reels' },
        { objective: 'Workspace aesthetic', format: 'Still' },
        { objective: 'Travel and inspiration', format: 'Reels' },
        { objective: 'Personal brand moment', format: 'Still' },
        { objective: 'Evening routine', format: 'Reels' },
      ],
    },
    {
      title: language === 'es' ? 'Hospitalidad y Gastronomía (En Cámara)' : 'Hospitality & Food (On Camera)',
      pieces: [
        { objective: 'Culinary experience', format: 'Reels' },
        { objective: 'Event atmosphere', format: 'Ad' },
        { objective: 'Table setting artistry', format: 'Still' },
        { objective: 'Menu storytelling', format: 'Reels' },
      ],
    },
  ];

  return (
    <div className="bg-cream pt-32 pb-20">
      {/* Hero */}
      <section className="px-6 py-16 bg-vainilla">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="font-serif text-5xl md:text-6xl font-bold text-stone-900 mb-6">
            Selected Moments
          </h1>
          <p className="text-xl text-stone-600 max-w-2xl mx-auto leading-relaxed">
            On-camera storytelling assets for launches, gifting, campaign moments—and founder lifestyle.
          </p>
        </div>
      </section>

      {/* Portfolio Sections */}
      {sections.map((section, sectionIdx) => (
        <section key={sectionIdx} className={`px-6 py-16 ${sectionIdx % 2 === 0 ? 'bg-cream' : 'bg-vainilla'}`}>
          <div className="max-w-6xl mx-auto">
            <h2 className="font-serif text-3xl font-bold text-stone-900 mb-10">
              {section.title}
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {section.pieces.map((piece, pieceIdx) => (
                <div key={pieceIdx} className="group">
                  {/* 4:5 Portrait Placeholder */}
                  <div 
                    className="bg-perla/40 border-2 border-dashed border-perla flex items-center justify-center mb-3 transition-all group-hover:border-terracota group-hover:bg-perla/60"
                    style={{ aspectRatio: '4/5' }}
                  >
                    <span className="text-stone-400 text-xs uppercase tracking-wider">4:5 Portrait</span>
                  </div>
                  {/* Caption */}
                  <p className="text-sm text-stone-600 leading-snug">
                    <span className="text-stone-900 font-medium">Objective:</span> {piece.objective} <span className="text-stone-400">|</span> <span className="text-terracota">{piece.format}</span>
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>
      ))}

      {/* CTA */}
      <section className="px-6 py-20 bg-stone-900 text-white">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-serif text-4xl font-bold mb-6">
            {language === 'es' ? 'Trabajemos Juntos' : 'Let\'s Work Together'}
          </h2>
          <p className="text-lg mb-8 opacity-90">
            {language === 'es' 
              ? 'Colaboraciones de marca, momentos de campaña y contenido de estilo de vida de fundadora.'
              : 'Brand collaborations, campaign moments, and founder lifestyle content.'}
          </p>
          <Link to="/contact">
            <Button className="bg-terracota text-white hover:bg-white hover:text-stone-900 px-10 py-6 text-lg rounded-full transition-all" data-testid="partner-cta">
              {language === 'es' ? 'Colaboremos' : 'Partner With Me'}
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default SelectedMoments;
